import React, { useRef } from 'react';
import { Box, Paragraph, Text } from '@zillow/constellation-10';

import { useWidth } from './hooks';

import HomeMarkerGray from '../images/icons/HomeMarkerGray';
import { asCurrency } from '../utils/numberUtils';

export interface RentRangeChartProps {
  upperBound: number;
  lowerBound: number;
  zestimate: number;
}

const MARKER_WIDTH_IN_PX = 80;

const RentRangeChart: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<RentRangeChartProps>>> = (
  props,
) => {
  const { upperBound, lowerBound, zestimate } = props;
  const range = upperBound - lowerBound;
  const offset = zestimate - lowerBound;
  const lineRef = useRef<HTMLDivElement>(null);
  const lineWidthInPixels = useWidth(lineRef);

  return (
    <Box aria-hidden="true" css={{ marginBottom: '400' }}>
      {lineWidthInPixels !== null && (
        <Box
          css={{ position: 'relative', width: `${MARKER_WIDTH_IN_PX}px`, textAlign: 'center' }}
          style={{ left: `${(offset / range) * lineWidthInPixels}px` }}
        >
          <Text css={{ backgroundColor: 'bg.softer', borderRadius: '23px', paddingInline: '300' }}>
            {asCurrency(zestimate)}
          </Text>
          <HomeMarkerGray style={{ background: 'transparent' }} />
        </Box>
      )}
      <Box
        ref={lineRef}
        css={{
          border: '1px solid {colors.border.subtle}',
          marginBottom: '250',
          marginInline: `${MARKER_WIDTH_IN_PX / 2}px`,
        }}
      />
      <Box css={{ display: 'flex' }}>
        <Box css={{ textAlign: 'left', width: '50%', marginLeft: `${MARKER_WIDTH_IN_PX / 2}px` }}>
          <Text textStyle="body-bold" color="text.subtle">
            {asCurrency(lowerBound)}
          </Text>
          <Paragraph textStyle="body" color="text.subtle">
            Low
          </Paragraph>
        </Box>
        <Box css={{ textAlign: 'right', width: '50%', marginRight: `${MARKER_WIDTH_IN_PX / 2}px` }}>
          <Text textStyle="body-bold" color="text.subtle">
            {asCurrency(upperBound)}
          </Text>
          <Paragraph textStyle="body" color="text.subtle">
            High
          </Paragraph>
        </Box>
      </Box>
    </Box>
  );
};

export default RentRangeChart;
